var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCopy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "20pt",
    height: "24pt",
    viewBox: "0 0 256.000000 256.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,256.000000) scale(0.100000,-0.100000)",
    fill: "#A51713",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M689 2546 c-99 -35 -185 -122 -213 -213 -7 -23 -6 -23 92 -23 88 0 101 2 118 21 43 49 42 49 715 49 l631 0 40 -22 c21 -12 49 -38 61 -58 l22 -35 3 -790 2 -790 -22 -45 c-13 -25 -39 -55 -58 -68 l-35 -23 -5 533 c-5 530 -5 533 -28 583 -31 67 -423 464 -497 503 l-50 27 -495 0 -495 0 -56 -28 c-67 -32 -141 -108 -172 -174 l-22 -48 0 -845 0 -845 33 -67 c36 -73 87 -124 161 -160 l46 -23 654 -3 653 -2 57 25 c108 50 183 149 202 268 12 72 14 77 39 77 58 0 170 78 216 151 55 88 55 75 52 965 l-3 819 -27 57 c-32 69 -97 136 -163 169 l-50 24 -685 2 c-542 2 -693 0 -721 -11z m711 -642 c0 -149 11 -186 75 -249 64 -64 100 -75 254 -75 l121 0 0 -644 0 -643 -23 -34 c-12 -18 -38 -44 -56 -56 l-34 -23 -605 0 -604 0 -40 22 c-21 12 -49 38 -61 58 l-22 35 -3 780 c-2 525 0 792 7 816 15 51 48 88 95 110 38 17 74 19 469 19 l427 0 0 -116z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618 1553 c-56 -35 -66 -117 -19 -164 l29 -29 307 0 307 0 29 29 c23 23 29 38 29 71 0 52 -13 76 -50 95 -24 12 -79 15 -317 15 -251 0 -291 -3 -315 -17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618 1114 c-35 -18 -48 -43 -48 -89 0 -47 13 -71 50 -90 25 -13 101 -15 514 -15 l486 0 30 28 c22 19 33 39 37 69 5 39 2 46 -30 78 l-35 35 -489 0 c-411 -1 -492 -3 -515 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599 661 c-41 -41 -41 -98 0 -143 l29 -33 500 0 500 0 26 24 c32 30 43 81 26 122 -26 61 -7 59 -553 59 l-499 0 -29 -29z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.33679caa3fda33ed509b50e3b1529c09.svg";
export { ForwardRef as ReactComponent };